import React, { useEffect } from "react";
import Banner from './banner/Banner'
import Job_cards from './job-card/Job_cards'
import Registration_form from './registration/Registration_form'

const Career = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    return (
        <>
            <Banner />
            <Job_cards />
            <div id="section1">
                <br></br>
                <br></br>
                <br></br>
                <Registration_form />
            </div>
        </>
    )
}

export default Career